import { Box } from "@mui/material";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useOnboarding } from "../../contexts/OnboardingContext";
import { ONBOARDING_STEPS } from "../../utils/constants";

export default function Onboarding() {
  const { currentStage, openOnboardingModal, isOnboardingModalOpen } =
    useOnboarding();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onboarding = location.pathname.includes("onboarding");

    // Handle LEARN_BASICS stage when on onboarding URL
    if (currentStage === ONBOARDING_STEPS.LEARN_BASICS && onboarding) {
      // Open modal if not already open
      if (!isOnboardingModalOpen) {
        openOnboardingModal();
      }

      // If just /onboarding, navigate to the first learning section
      if (location.pathname === "/onboarding") {
        navigate("/onboarding/posture/controls", { replace: true });
      }
      // Otherwise, stay at the current path (e.g., /onboarding/inventory/environment)
    }

    // Handle COMPLETED stage
    if (currentStage === ONBOARDING_STEPS.COMPLETED && onboarding) {
      navigate("/");
    }
  }, [
    location,
    currentStage,
    isOnboardingModalOpen,
    navigate,
    openOnboardingModal,
  ]);

  return <Box></Box>;
}
